import { useState } from "react";
import IconInfo from "../../components/icons/IconInfo";
import FlexList from "../../components/settings/FlexList";
import useConversationStats from "./useConversationStats";

const noop = () => {};

function formatDuration(totalSeconds) {
    if (totalSeconds == null) return "—";
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.round(totalSeconds % 60);
    return `${minutes} хв ${seconds} с`;
}

function copyLink(hashCode) {
    if (!hashCode) return;
    const text = `https://games.english-from-zero.ovh/start?type=1&id=${hashCode}`;
    navigator.clipboard?.writeText(text).catch(() => {});
}

const progressHeaders = {
    outerUserId: { name: "name", name1: "surname", name2: "username" },
    isFinished: {},
    icons: {
        "icon-messages": { name: "icon-messages", type: "icon", url: "/messages/byconvprogress", value: "", mode: "card" },
    },
};

export default function ConversationInfoPanel({ conversation, estimationGroups, stages, botErrors }) {
    const [isOpen, setIsOpen] = useState(false);
    const { stats } = useConversationStats(isOpen ? conversation?.id : undefined);

    const errorCount = (botErrors || []).filter((entry) => entry.severity === "ERROR").length;
    const warningCount = (botErrors || []).filter((entry) => entry.severity === "WARNING").length;
    const totalBotErrors = errorCount + warningCount;
    const botErrorsClass = errorCount > 0 ? "conversation-info-row-error" : warningCount > 0 ? "conversation-info-row-warning" : "";

    return (
        <div className="functional-panelbutton" onClick={() => setIsOpen((prev) => !prev)}>
            <IconInfo fillColor="icon-blue" style={{ height: 20, width: 20 }} />

            {isOpen ? (
                <div className="conversation-info-panel" onClick={(e) => e.stopPropagation()}>
                    <div className="conversation-info-header">
                        <h3>{conversation?.name}</h3>
                        {conversation?.description ? <p className="conversation-info-description">{conversation.description}</p> : ""}
                        {conversation?.hashCode ? (
                            <div className="conversation-info-row conversation-info-hashcode" onClick={() => copyLink(conversation.hashCode)}>
                                <span>Посилання:</span>
                                <span className="conversation-info-copy">{conversation.hashCode} (копіювати)</span>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>

                    <div className="conversation-info-columns">
                        <div className="conversation-info-column">
                            <p className="toolbar-popup-title">Функція оцінки</p>
                            <div className="conversation-info-row">
                                <span>{conversation?.estimationFunction?.name || "—"}</span>
                            </div>
                            {estimationGroups && estimationGroups.length > 0 ? (
                                <ul className="toolbar-popup-list toolbar-popup-list-readonly">
                                    {estimationGroups.map((group) => (
                                        <li key={group.id}>{group.name}</li>
                                    ))}
                                </ul>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="conversation-info-column">
                            <p className="toolbar-popup-title">Pipeline</p>
                            <div className="conversation-info-row">
                                <span>{conversation?.stageTypeId?.name || "—"}</span>
                            </div>
                            {stages && stages.length > 0 ? (
                                <ul className="toolbar-popup-list toolbar-popup-list-readonly">
                                    {stages.map((stage) => (
                                        <li key={stage.id} style={{ borderLeft: `3px solid ${stage.color || "#7f7f7f"}` }}>
                                            {stage.name}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="conversation-info-column">
                            <p className="toolbar-popup-title">Аналітика</p>
                            <div className={"conversation-info-row " + botErrorsClass}>
                                <span>Помилки бота:</span>
                                <span>
                                    {totalBotErrors > 0
                                        ? `${totalBotErrors} (${errorCount} помилок, ${warningCount} попереджень)`
                                        : "0"}
                                </span>
                            </div>
                            {stats ? (
                                <div className="conversation-info-stats">
                                    <div className="conversation-info-row">
                                        <span>Розпочали:</span>
                                        <span>{stats.startedCount}</span>
                                    </div>
                                    <div className="conversation-info-row">
                                        <span>Завершили:</span>
                                        <span>{stats.finishedCount}</span>
                                    </div>
                                    {stats.averageScore != null ? (
                                        <div className="conversation-info-row">
                                            <span>Середній:</span>
                                            <span>
                                                {stats.averageScore.toFixed(1)} {stats.scoreUnit}
                                            </span>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {stats.bestScore ? (
                                        <div className="conversation-info-row">
                                            <span>Найкращий:</span>
                                            <span>
                                                {stats.bestScore.value} {stats.scoreUnit} — {stats.bestScore.userName}
                                            </span>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {stats.worstScore ? (
                                        <div className="conversation-info-row">
                                            <span>Найгірший:</span>
                                            <span>
                                                {stats.worstScore.value} {stats.scoreUnit} — {stats.worstScore.userName}
                                            </span>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {stats.averageDurationSeconds != null ? (
                                        <div className="conversation-info-row">
                                            <span>Сер. час:</span>
                                            <span>{formatDuration(stats.averageDurationSeconds)}</span>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {stats.averageMessageCount != null ? (
                                        <div className="conversation-info-row">
                                            <span>Сер. відповідей:</span>
                                            <span>{stats.averageMessageCount.toFixed(1)}</span>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            ) : (
                                <p>Завантаження...</p>
                            )}
                        </div>
                    </div>

                    <div className="conversation-info-users">
                        <p className="toolbar-popup-subtitle">Хто проходив</p>
                        {conversation?.id ? (
                            <FlexList
                                name=""
                                table="table"
                                thead="table-header-bot-con"
                                htr="table-h-tr-bot-con"
                                th="table-h-th-bot-con "
                                tbody="table-body"
                                btr="table-b-tr"
                                td="table-b-td"
                                url={"/api/conversationprogress?conversation=" + conversation.id}
                                done={isOpen}
                                stateHundler={noop}
                                onRefreshHundler={noop}
                                headers={progressHeaders}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
